import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M2.73 7.625a.775.775 0 0 0 0 1.102l3.929 3.895a.79.79 0 0 0 1.112 0 .775.775 0 0 0 0-1.103l-2.59-2.565h7.533a.78.78 0 0 0 .786-.779.78.78 0 0 0-.786-.779h-7.53l2.585-2.565a.775.775 0 0 0 0-1.103.79.79 0 0 0-1.112 0l-3.93 3.894z"
    }, null, -1)
  ]))]))
}
export default { render: render }